// extracted by mini-css-extract-plugin
export default {"card":"MiniCourseForm_card__AorH1","selector":"MiniCourseForm_selector__fD0f2"};